import { createFileRoute, Link } from "@tanstack/react-router";

export const Route = createFileRoute("/auth/_auth-layout/signup/success")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <div className="flex w-full flex-col  items-center rounded-3xl bg-white text-left gap-5">
      <img
        src="/volume-logo.svg"
        className="self-center"
        width={200}
        height={200}
        alt="Volume logo"
      />
      <h1 className="mt-8 px-8 text-center text-5xl font-extrabold">
        Sign Up Successful
      </h1>
      <p className="mt-8 px-8 text-center">
        You will receive an email shortly with instructions on how to login to
        your account.
      </p>
      <Link
        to="/auth/signin"
        className="text-volume-text-purple hover:underline hover:cursor-pointer"
      >
        Sign In now?{" "}
      </Link>
    </div>
  );
}
